import React, { useState, useEffect, useReducer, useRef } from 'react';
import { SActionBtn, SBack, STableActions, SFuncModal } from 'shj-components'
import { Form, Button, Select, Divider, Row, Col, message, Input, Table, Popconfirm, Card, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { FieldMapDom } from './fieldMap';
import { verifyJSON } from './addOrEdit';
import { addBusMattersOfBill,busMattersOfBillList,deleteBillAndMappingDataById} from '@/services/integrationConfig'
const Option = Select.Option;
const { TextArea } = Input;
export function AccountSetsFn({ fn, ...rest }: any) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `关联账套`,
    width: 1500,
    vanish: true,
    content: <AccountSetsDom onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}
const AccountSetsDom = ({ onClose, fn, billSetList, ...rest }: any) => {
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [editingKey, setEditingKey] = useState('');
  const [data, setData] = useState<any>([]);

  const isEditing = (record: any) => record.key === editingKey;
  const [curBillSets, setCurBillSets] = useState<any>({});
  const [financeJson, setFinanceJson] = useState<string>();
  const [editFinanceJson, setEditFinanceJson] = useState<boolean>(false);
  const editJson = (record: any) => {
    setCurBillSets(record);
    setEditFinanceJson(true);
    setFinanceJson(record?.financeJson || '');
    form2.setFieldsValue({
      financeJson: record.financeJson,
    });
  };

  const cancel = (index: number, record: any) => {
    if (record.id) {
      setEditFinanceJson(false);
    } else {
      let newData = [...data];
      newData.splice(index, 1);
      setData(newData);
      setEditingKey('');
      setEditFinanceJson(false);
      if (data.length > 0) {
        setCurBillSets(data[0]);
      }
    }
  };
  const columns = [
    {
      title: '账套名称',
      dataIndex: 'billId',
      editable: true,
      ellipsis: true,
      render: (text: any, record: any) => {
        let find = billSetList.find((e: any) => e.billId == text);
        return (
          <Tooltip title={record?.billName || find?.billName}>
            <div
              style={{ cursor: 'pointer', color: text === curBillSets.billId ? '#3d7eff' : '#000000D9' }}
              onClick={() => {
                if (editFinanceJson) return;
                setCurBillSets(record);
              }}
            >
              {record?.billName || find?.billName}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      // width: 150,
      render: (_: any, record: any, index: number) => {
        const editable = isEditing(record);
        return (
          <div>
            {editable || (editFinanceJson && record.billId === curBillSets.billId) ? (
              <STableActions>
                <SActionBtn
                  onClick={() => {
                    save(record);
                  }}
                >
                  保存
                </SActionBtn>
                <SActionBtn
                  onClick={() => {
                    cancel(index, record);
                  }}
                >
                  取消
                </SActionBtn>
              </STableActions>
            ) : (
              <STableActions>
                <SActionBtn
                  onClick={() => {
                    editJson(record);
                  }}
                  disabled={editFinanceJson && curBillSets.id !== record.id}
                >
                  编辑
                </SActionBtn>
                  <SActionBtn title="是否删除？" danger confirm
                onClick={() => onDelRow(record)} okText="是" cancelText="否" disabled={editFinanceJson && curBillSets.id !== record.id}>
                    删除
                  </SActionBtn>
              </STableActions>
            )}
          </div>
        );
      },
    },
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: any) => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const filteredOptions = billSetList.filter((item: any) => {
    return data.findIndex((e: any) => e.billId === item.billId) === -1;
  });

  const EditableCell = ({ editing, dataIndex, title, record, children, ...restProps }: any) => {
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `请选择${title}!`,
              },
            ]}
          >
            <Select>
              {filteredOptions.map((item: any) => {
                return (
                  <Option key={item.id} value={item.billId}>
                    {item.billName}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };
  const save = async (record: any) => {
    try {
      let row = { ...record };
      if (!record?.billId) {
        row = await form.validateFields();
      }
      if (!financeJson) {
        message.error('请输入财务结构化参数');
        return;
      } else if (!verifyJSON(financeJson)) {
        message.error('财务结构化参数JSON格式错误');
        return;
      }
      const billSetObj = billSetList.find((e: any) => e.billId === row?.billId);
      let params: any = {
        busMattersId: rest.id,
        billId: row?.billId,
        billName: billSetObj?.billName,
        financeJson,
      };

      if (record?.id) {
        params.id = record?.id;
      }
      addBusMattersOfBill(params).then((resp: any) => {
          message.success(resp?.message || '操作成功');
          setEditingKey('');
          setEditFinanceJson(false);
          initFn();
          setCurBillSets({
            ...curBillSets,
            financeJson,
          });
        });
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };
  const onAddRow = () => {
    setFinanceJson('');
    form2.setFieldsValue({
      financeJson: '',
    });
    setCurBillSets({});
    setEditFinanceJson(true);
    form.setFieldsValue({
      billId: '',
    });
    const newData = [...data];
    const obj = {
      key: newData[newData.length - 1]?.key + 1 || 1,
      billId: '',
    };
    newData.push(obj);
    setData(newData);
    setEditingKey(obj.key);
  };
  const onDelRow = (record: any) => {
    deleteBillAndMappingDataById(record?.id).then((resp: any) => {
      message.success('删除成功');
      setEditFinanceJson(false);
      initFn().then((arr = []) => {
        if (record?.billId === curBillSets?.billId && arr.length > 0) {
          setCurBillSets(arr[0]);
        } else {
          setCurBillSets({});
        }
      });
    });
  };
  useEffect(() => {
    initFn();
  }, []);

  const initFn = () => {
    return  busMattersOfBillList({ busMattersId: rest.id }).then((resp: any) => {
        let arr = resp || [];
        arr.map((e: any, index: number) => {
          e.key = index + 1;
        });
        setData(arr);
        if (arr.length > 0 && !curBillSets?.billId) {
          setCurBillSets(arr[0]);
        }
        return arr;
      });
  };

  return (
    <div style={{ padding: 15 }}>
      <div style={{ display: 'flex', padding: 15 }}>
        <div style={{ width: 300 }}>
          <Button
            type="primary"
            style={{ borderRadius: '5px', marginBottom: '10px' }}
            onClick={onAddRow}
            disabled={!!editingKey}
          >
            新增关联账套
          </Button>
          <Form form={form} component={false}>
            <div>
              <Table
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                columns={mergedColumns}
                dataSource={data}
                size="small"
                bordered={true}
                pagination={false}
              />
            </div>
          </Form>
        </div>

        <div style={{ flexGrow: 1, height: '100%', width: 'calc(100% - 200px)' }}>
          <Card title="字段映射表" size={'small'} bodyStyle={{ height: '100%', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '5px' }}>
              <span>
                业务事项编码：{rest.code}-{curBillSets?.billId}
              </span>
              <span>业务事项名称：{rest.name}</span>
            </div>
            {curBillSets?.billId && !editFinanceJson ? (
              <FieldMapDom
                onClose={onClose}
                fn={fn}
                {...curBillSets}
                businessParamJson={rest?.businessParamJson || ''}
              ></FieldMapDom>
            ) : (
              <Form form={form2} component={false}>
                <Form.Item label={'财务结构化参数'} name={'financeJson'}>
                  <TextArea
                    autoSize={{ minRows: 8 }}
                    onChange={(e) => {
                      let str = e?.target?.value || '';
                      setFinanceJson(str);
                    }}
                  />
                </Form.Item>
              </Form>
            )}
          </Card>
        </div>
      </div>
      <Row>
        <Col span={24}>
          <Divider />
        </Col>
        <Col span={24} style={{ textAlign: 'right' }}>
          <Button htmlType="button" onClick={onClose} style={{ marginLeft: '8px' }}>
            取消
          </Button>
        </Col>
      </Row>
    </div>
  );
};
